import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Set a default timezone, for example: 'Europe/Bucharest'
dayjs.tz.setDefault("Europe/Bucharest");

export default dayjs;
